module.exports = __webpack_public_path__ + "static/tesla-6713c56c26340f5429165bb75c4b868e.jpg";